"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/slider.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  _createClass(Slider, null, [{
    key: "circlePositionValue",
    value: function circlePositionValue(value, containerWidth) {
      var circleRadius = 10 * 100;
      return value - circleRadius / containerWidth;
    }
  }]);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWheel", function (event) {
      var _this$state = _this.state,
          disabled = _this$state.disabled,
          value = _this$state.value;
      var onChange = _this.props.onChange;

      if (disabled) {
        return;
      }

      var rect = _this.getContainerRect();

      var position = value;
      position = event.deltaY > 0 ? position - 2 : position + 2;

      if (position > 100) {
        position = 100;
      }

      if (position < 0) {
        position = 0;
      }

      if (value !== position) {
        _this.setState({
          value: position,
          circlePosition: Slider.circlePositionValue(position, rect.width)
        }, function () {
          return onChange(_this.state.value);
        });
      }

      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      var _this$state2 = _this.state,
          disabled = _this$state2.disabled,
          value = _this$state2.value;
      var onChange = _this.props.onChange;

      if (disabled) {
        return;
      }

      var rect = _this.getContainerRect();

      var clientX = event.type !== 'touchmove' ? event.clientX : event.changedTouches[0].clientX;
      var ratio = (clientX - rect.left) / rect.width;

      if (ratio > 1) {
        ratio = 1;
      }

      if (ratio < 0) {
        ratio = 0;
      }

      var position = Math.round(100 * ratio);

      if (value !== position) {
        _this.setState({
          value: position,
          circlePosition: Slider.circlePositionValue(position, rect.width)
        }, function () {
          return onChange(_this.state.value);
        });
      }

      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMovementStart", function (event) {
      _this.setState({
        movementStarted: true
      });

      if (event.type === 'mousedown') {
        document.addEventListener('mousemove', _this.handleClick);
        document.addEventListener('mouseup', _this.handleMovementStop);
      }

      if (event.type === 'touchstart') {
        document.addEventListener('touchmove', _this.handleClick, {
          passive: false
        });
        document.addEventListener('touchend', _this.handleMovementStop);
      } // Cancel text selection


      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMovementStop", function (event) {
      _this.setState({
        movementStarted: false
      });

      if (event.type === 'mouseup') {
        document.removeEventListener('mousemove', _this.handleClick);
        document.removeEventListener('mouseup', _this.handleMovementStop);
      }

      if (event.type === 'touchend') {
        document.removeEventListener('touchmove', _this.handleClick);
        document.removeEventListener('touchend', _this.handleMovementStop);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (event) {
      var value = _this.state.value;
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;
      if (disabled) return;

      switch (event.keyCode) {
        case 37:
          // arrow left
          if (value > 0) {
            _this.setState(function (state) {
              return {
                value: state.value - 1,
                circlePosition: state.circlePosition - 1
              };
            }, onChange(value - 1));
          }

          break;

        case 39:
          // arrow right
          if (value < 100) {
            _this.setState(function (state) {
              return {
                value: state.value + 1,
                circlePosition: state.circlePosition + 1
              };
            }, onChange(value + 1));
          }

          break;

        default:
          break;
      }
    });

    var _this$props2 = _this.props,
        _disabled = _this$props2.disabled,
        _value = _this$props2.value;
    _this.state = {
      disabled: _disabled,
      movementStarted: false,
      value: _value
    };
    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.state.value;
      var rect = this.getContainerRect();
      this.setState({
        circlePosition: Slider.circlePositionValue(value, rect.width)
      });
    }
  }, {
    key: "getContainerRect",
    value: function getContainerRect() {
      return this.container.getBoundingClientRect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      var _this$state3 = this.state,
          circlePosition = _this$state3.circlePosition,
          disabled = _this$state3.disabled,
          movementStarted = _this$state3.movementStarted,
          value = _this$state3.value;
      var slider = {
        'vn-slider': true
      };
      var sliderTrack = {
        'vn-slider__track': true,
        'vn-slider__track--disabled': disabled
      };
      var sliderTrackProgressClasses = {
        'vn-slider__track': true,
        'vn-slider__track--disabled': disabled,
        'vn-slider__progress': true,
        'vn-slider__progress--disabled': disabled
      };
      var sliderCircleClasses = {
        'vn-slider__circle': true,
        'vn-slider__circle--on': movementStarted,
        'vn-slider__circle--disabled': disabled
      };

      if (className) {
        slider[className] = true;
      }

      return _react.default.createElement("div", _extends({}, this.props, {
        role: "slider",
        tabIndex: 0,
        "aria-valuenow": value,
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        ref: function ref(c) {
          _this2.container = c;
        },
        className: (0, _classnames.default)(slider),
        onClick: this.handleClick,
        onWheel: this.handleWheel,
        onKeyDown: this.handleKeyDown
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(sliderTrack)
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(sliderTrackProgressClasses),
        style: {
          width: "".concat(value, "%")
        }
      }), _react.default.createElement("div", {
        role: "slider",
        tabIndex: 0,
        "aria-valuenow": value,
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        className: (0, _classnames.default)(sliderCircleClasses),
        onMouseDown: this.handleMovementStart,
        onTouchStart: this.handleMovementStart,
        style: {
          left: "".concat(circlePosition, "%")
        }
      }));
    }
  }]);

  return Slider;
}(_react.default.Component);

Slider.defaultProps = {
  className: '',
  value: 0,
  disabled: false,
  onChange: function onChange() {}
};
Slider.propTypes = {
  className: _propTypes.default.string,
  value: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
Slider.displayName = 'Slider';
var _default = Slider;
exports.default = _default;